import React from 'react';
import './Legal.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <h1>Privacy Policy</h1>
        <p className="legal-updated">Last updated: June 19, 2026</p>

        <section>
          <h2>Overview</h2>
          <p>
            GetVetBill.com ("VetBill," "we," "us," or "our") is committed to protecting your privacy.
            This Privacy Policy explains how we collect, use, and safeguard your information when you
            use our website and services.
          </p>
        </section>

        <section>
          <h2>Information We Collect</h2>
          <h3>Account Information</h3>
          <p>When you create an account, we collect your first name, last name, email address, and password (stored in hashed form).</p>

          <h3>Veterinary Bill Data</h3>
          <p>
            When you upload a veterinary bill or estimate, we extract service descriptions, costs,
            hospital names, and location data (city, state, zip code). We use automated tools to
            redact personal information (pet names, owner names, account numbers) from uploaded images
            before they are stored or displayed.
          </p>

          <h3>Usage Data</h3>
          <p>We may collect standard usage data such as IP addresses, browser type, and pages visited to improve our service.</p>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <ul>
            <li>To provide and maintain our service</li>
            <li>To aggregate and display anonymized veterinary pricing data</li>
            <li>To send password reset emails when requested</li>
            <li>To respond to support requests</li>
            <li>To improve our service and user experience</li>
          </ul>
        </section>

        <section>
          <h2>Data Sharing</h2>
          <p>
            Aggregated, anonymized pricing data (service categories, price ranges, hospital names, and locations)
            is displayed publicly on VetBill to help pet owners compare costs. We do not sell your personal
            information to third parties.
          </p>
          <p>
            Uploaded bill images are processed using OpenAI's API to extract structured data. Images are sent
            securely and are not retained by OpenAI for training purposes.
          </p>
        </section>

        <section>
          <h2>Data Security</h2>
          <p>
            We use industry-standard security measures including encrypted connections (HTTPS),
            hashed passwords (bcrypt), and secure session management. However, no method of
            transmission over the internet is 100% secure.
          </p>
        </section>

        <section>
          <h2>Your Rights</h2>
          <p>You may:</p>
          <ul>
            <li>Access and update your account information at any time</li>
            <li>Request deletion of your account and associated data</li>
            <li>Opt out of any non-essential communications</li>
          </ul>
          <p>To exercise these rights, contact us at <a href="mailto:privacy@getvetbill.com">privacy@getvetbill.com</a>.</p>
        </section>

        <section>
          <h2>Cookies</h2>
          <p>
            We use a session cookie to keep you logged in. We do not use tracking cookies or
            third-party advertising cookies.
          </p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify users of significant
            changes by posting the updated policy on this page with a revised date.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>If you have questions about this Privacy Policy, contact us at <a href="mailto:privacy@getvetbill.com">privacy@getvetbill.com</a>.</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
